import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccommodationRoomingListState, MciCredential, VatCredential } from "../objects/accommodationRoomingListState";
import { EMPTY_ROOMING_LIST_HISOTRY_CRITERIA, EMPTY_ROOMING_LIST_GENERATION_CRITERIA } from "../constants/accommodationRoomingListConstants";
import { RoomingListHistory, RoominglistHistoryCriteria } from "../objects/roomingListHistory";
import { RoomingListGeneration, RoominglistGenerationCriteria } from "../objects/roomingListGeneration";

const initialState: AccommodationRoomingListState = {
    mci_credential: { event: null, event_date: null },
    vat_credential: { start_date: null, end_date: null },
    rooming_list_history: [],
    rooming_list_history_search: "",
    rooming_list_history_criteria: EMPTY_ROOMING_LIST_HISOTRY_CRITERIA,
    rooming_list_generation: [],
    rooming_list_generation_criteria: EMPTY_ROOMING_LIST_GENERATION_CRITERIA,
    rooming_list_generation_search: ""
};

const setMciCredentialEventReducer = (state: AccommodationRoomingListState, action: PayloadAction<MciCredential>): AccommodationRoomingListState => ({
    ...state, mci_credential: action.payload
});
const setVatCredentialEventReducer = (state: AccommodationRoomingListState, action: PayloadAction<VatCredential>): AccommodationRoomingListState => ({
    ...state, vat_credential: action.payload
});

// ------------------- rooming list history -------------------------- //
const setRoomingListHistoryReducer = (state: AccommodationRoomingListState, action: PayloadAction<RoomingListHistory[]>): AccommodationRoomingListState => ({
    ...state, rooming_list_history: action.payload
});
const setRoomingListHistoryCriteriaReducer = (state: AccommodationRoomingListState, action: PayloadAction<RoominglistHistoryCriteria>): AccommodationRoomingListState => ({
    ...state, rooming_list_history_criteria: action.payload
});
const setRoomingListHistorySearchReducer = (state: AccommodationRoomingListState, action: PayloadAction<string>): AccommodationRoomingListState => ({
    ...state, rooming_list_history_search: action.payload, rooming_list_history_criteria: {...state.rooming_list_history_criteria, page: 0}
});

// ------------------- rooming list generation -------------------------- //
const setRoomingListGenerationReducer = (state: AccommodationRoomingListState, action: PayloadAction<RoomingListGeneration[]>): AccommodationRoomingListState => ({
    ...state, rooming_list_generation: action.payload
});
const setRoomingListGenerationCriteriaReducer = (state: AccommodationRoomingListState, action: PayloadAction<RoominglistGenerationCriteria>): AccommodationRoomingListState => ({
    ...state, rooming_list_generation_criteria: action.payload
});
const setRoomingListGenerationSearchReducer = (state: AccommodationRoomingListState, action: PayloadAction<string>): AccommodationRoomingListState => ({
    ...state, rooming_list_generation_search: action.payload
});



export const accommodation_rooming_list = createSlice({
    name: 'accommodation_rooming_list',
    initialState,
    reducers: {
        setMciCredentialEvent: setMciCredentialEventReducer,
        setVatCredentialEvent: setVatCredentialEventReducer,
        setRoomingListHistory: setRoomingListHistoryReducer,
        setRoomingListHistoryCriteria: setRoomingListHistoryCriteriaReducer,
        setRoomingListGeneration: setRoomingListGenerationReducer,
        setRoomingListGenerationCriteria: setRoomingListGenerationCriteriaReducer,
        setRoomingListHistorySearch: setRoomingListHistorySearchReducer,
        setRoomingListGenerationSearch: setRoomingListGenerationSearchReducer
    }
});

export const {
    setMciCredentialEvent,
    setVatCredentialEvent,
    setRoomingListHistory,
    setRoomingListHistoryCriteria,
    setRoomingListGeneration,
    setRoomingListGenerationCriteria,
    setRoomingListHistorySearch,
    setRoomingListGenerationSearch
} = accommodation_rooming_list.actions;